(function () {
  function sanitizeViewport() {
    try {
      let metas = Array.prototype.slice.call(document.querySelectorAll('meta[name="viewport"]'));
     
      metas.forEach(function(m){
        let c = (m.getAttribute('content') || '').toLowerCase();
        if (c.indexOf('maximum-scale') !== -1 || c.indexOf('user-scalable=0') !== -1) {
          if (m.parentNode) m.parentNode.removeChild(m);
        }
      });
      
      if (!document.querySelector('meta[name="viewport"]')) {
        let mv = document.createElement('meta');
        mv.setAttribute('name', 'viewport');
        mv.setAttribute('content', 'width=device-width, initial-scale=1');
        document.head.insertBefore(mv, document.head.firstChild);
      }
    } catch (e) {}
  }
 
  sanitizeViewport();

  try { document.addEventListener('DOMContentLoaded', sanitizeViewport); } catch (e) {}
 
  try {
    let obs = new MutationObserver(function(muts){
      for (let i=0;i<muts.length;i++) {
        let nodes = muts[i].addedNodes || [];
        for (let j=0;j<nodes.length;j++) {
          let n = nodes[j];
          if (n.tagName === 'META' && n.getAttribute('name') === 'viewport') {
            sanitizeViewport();
            return;
          }
        }
    
        if (muts[i].type === 'attributes') {
          let t = muts[i].target;
          if (t && t.tagName === 'META' && t.getAttribute('name') === 'viewport') {
            sanitizeViewport();
            return;
          }
        }
      }
    });
    obs.observe(document.head, { childList: true, attributes: true, attributeFilter: ['name','content'] });
  } catch(e) {}
})();
